import React, { useEffect, useState } from "react";
import Loader from "../../../../components/Loader/Loader";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import axios from "axios";
import config from "../../../../config/config";
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../../common/Constant";
import { toastError, toastSuccess } from "../../../../common/Toast";

export const RecallPrice = () => {
  const [loading, setLoading] = useState(false);
  const [allSites, setAllSites] = useState([]);
  const [recallprice, setRecallPrice] = useState({
    portal: false,
    ecommEnabled: false,
    ecommSites: [],
  });

  const token = localStorage.getItem("Token");

  useEffect(() => {
    // Get existing config
    axios
      .get(`${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=Promo rules`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          const value = res.data.ResponseData || [];

          const portal = value.find(
            (item) => item.AppConfigkey === "Portal Recall Price Settings"
          );
          const ecomm = value.find(
            (item) => item.AppConfigkey === "Ecommerce Recall Price Settings"
          );

          const ecommSites = ecomm?.AppConfigvalue
            ? ecomm.AppConfigvalue.split(",").map((v) => v.trim())
            : [];

          setRecallPrice({
            portal: portal?.AppConfigvalue == 1,
            ecommEnabled: ecommSites.length > 0,
            ecommSites: ecommSites,
          });
        }
      })
      .catch((err) => console.log(err));

    // Load all site options
    axios
      .get(`${config.storeConfigBaseUrl}/storeconfig/getmultisitelist`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        const responseData = response.data.ResponseData || [];
        const options = responseData.map((item) => ({
          label: item.AppConfigvalue.trim(),
          value: item.AppConfigkey.trim(),
        }));
        setAllSites(options);
      })
      .catch((err) => console.log(err));
  }, []);

  const handleToggle = (type) => {
    if (type === "portal") {
      const updatedPortal = !recallprice.portal;
      updateConfig(updatedPortal, recallprice.ecommSites);
      setRecallPrice({ ...recallprice, portal: updatedPortal });
    } else if (type === "ecomm") {
      const newEcommEnabled = !recallprice.ecommEnabled;
      const updatedSites = newEcommEnabled ? recallprice.ecommSites : [];
      updateConfig(recallprice.portal, updatedSites);
      setRecallPrice({
        ...recallprice,
        ecommEnabled: newEcommEnabled,
        ecommSites: updatedSites,
      });
    }
  };

  const handleSiteChange = (siteValue) => {
    const current = recallprice.ecommSites.includes(siteValue);
    const updatedSites = current
      ? recallprice.ecommSites.filter((v) => v !== siteValue)
      : [...recallprice.ecommSites, siteValue];

    setRecallPrice({ ...recallprice, ecommSites: updatedSites });
    updateConfig(recallprice.portal, updatedSites);
  };

  const updateConfig = (portalValue, ecommSites) => {
    const data = [
      {
        AppConfigkey: "Portal Recall Price Settings",
        AppConfigvalue: portalValue ? 1 : 0,
      },
      {
        AppConfigkey: "Ecommerce Recall Price Settings",
        AppConfigvalue: ecommSites.join(","),
      },
    ];

    const jsonobj = { StoreConfig: data };
    const jsonstring = JSON.stringify(jsonobj);
    setLoading(true);

    axios
      .post(
        `${config.storeConfigBaseUrl}/storeconfig/upsert`,
        {
          type: "Promo rules",
          storeconfigxml: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setLoading(false);
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
        } else {
          toastError(ERROR_MESSAGE);
        }
      })
      .catch(() => {
        setLoading(false);
        toastError(ERROR_MESSAGE);
      });
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div className="card">
            <div className="card-header ">
              <h4 className="card-title mb-0">Recall Price Setting</h4>
            </div>

            <div className="card-body row align-items-center">
              <div className="col-md-3">
                <label>Enable Portal Recall Price</label>
              </div>
              <div className="form-check form-switch col-md-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  onChange={() => handleToggle("portal")}
                  checked={recallprice.portal}
                />
              </div>
            </div>

            <div className="card-body row align-items-start">
              <div className="col-md-3">
                <label>Enable Ecommerce Recall Price</label>
              </div>
              <div className="form-check form-switch col-md-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  onChange={() => handleToggle("ecomm")}
                  checked={recallprice.ecommEnabled}
                />
              </div>

              {recallprice.ecommEnabled && (
                <div className="col-md-12 mt-4 ms-3">
                  <div className="row">
                    {allSites.map((site) => (
                      <div key={site.value} className="form-check col-md-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={recallprice.ecommSites.includes(site.value)}
                          onChange={() => handleSiteChange(site.value)}
                          id={`site-${site.value}`}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`site-${site.value}`}
                        >
                          {site.label}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
